<template>
  <div class="tips-error" v-show="state.errorText">
    <img class="warn-icon" src="@/assets/images/icons/warn-icon.png" />
    <div v-html="state.errorText"></div>
  </div>
  <el-form ref="formRef" :model="ruleForm" :rules="rules" class="form-wrapper" @keyup.enter="onSubmit">
    <el-form-item prop="account">
      <el-input class="ipt-common" :placeholder="$t('form.emailTips')" v-model="ruleForm.account" />
    </el-form-item>
    <el-form-item prop="password">
      <el-input :placeholder="$t('form.password')" type="password" v-model="ruleForm.password" show-password />
    </el-form-item>
    <el-form-item prop="code" @click.stop="() => { }">
      <VerifyCodeInput v-model:value="ruleForm.code" ref="verifyCodeRef" />
    </el-form-item>
    <el-button class="submit-button" type="primary" @click="onSubmit" :loading="state.isLoading">
      {{ $t('form.login') }}
    </el-button>
    <div class="other-tool">
      <span class="hover-link" @click="$emits('changeLoginStatus', 'forgetPsd')">{{
        $t('form.forgetPass')
        }}</span>
      <span class="hover-link" @click="$emits('changeLoginStatus', 'register')">{{
        $t('form.register')
        }}</span>
    </div>
    <div class="google-tool">
      <div class="line1"></div>
      or
      <div class="line2"></div>
    </div>
    <div id="google-button" :data-width="400" :data-locale="dataLocale">
      <!-- <img class="google-img" src="@/assets/images/common/google.png" />
      {{ $t('form.continueGoogle') }} -->
    </div>
    <!-- <div class="tip-tool">
      <span class="text1"> {{ $t('form.notAccount') }}</span>
      <span class="text2"> {{ $t('form.signNow') }}</span>
    </div> -->
  </el-form>
</template>

<script setup>
import { googleLogin, userLogin } from '@/apis/user'
import { useUserStore } from '@/stores'
import { encryptPwd } from '@/utils/encrypt'
import reg from '@/utils/reg'
import { initGoogle, useGoogle } from '@/utils/useGoogleLogin'
import CryptoJS from 'crypto-js'
import dayjs from 'dayjs'
import { ElMessage } from 'element-plus'
import { computed, defineEmits, defineExpose, onMounted, reactive, ref, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import VerifyCodeInput from './VerifyCodeInput.vue'

const $emits = defineEmits(['changeLoginStatus', 'showError'])
const userStore = useUserStore()
const { t } = useI18n()
const formRef = ref()
const verifyCodeRef = ref()
const router = useRouter()
const $route = useRoute()
const dataLocale = computed(() => {
  return userStore.language === 'cn' ? 'zh_CN' : userStore.language
})
const state = reactive({
  isLoading: false,
  errorText: '',
  ruleForm: {
    account: userStore.defaultEmail,
    password: '',
    code: '',
  },
  rules: {
    account: [
      {
        required: true,
        trigger: 'blur',
        message: t('form.verifyEmpty'),
      },
      {
        pattern: reg.mailReg,
        trigger: 'blur',
        message: t('form.holder.inputEmailAccount'),
      },
    ],
    password: [
      {
        required: true,
        trigger: 'blur',
        message: t('form.verifyEmpty'),
      },
      {
        pattern: reg.passwordReg,
        trigger: 'blur',
        message: t('form.verifyPass'),
      },
    ],
    code: [
      {
        required: true,
        trigger: 'blur',
        message: t('form.verifyEmpty'),
      },
    ],
  },
})
const { ruleForm, rules } = toRefs(state)
// 提交回调
const onSubmit = async () => {
  if (state.isLoading) return
  state.isLoading = true
  formRef.value.validate(async (valid) => {
    if (valid) {
      const params = {
        account: ruleForm.value.account,
        password: ruleForm.value.password,
        code: ruleForm.value.code,
        deviceCode: finger(),
        device: 'pc',
        date: dayjs().valueOf(),
        uuid: verifyCodeRef.value.getId(),
      }
      // console.log(params.password);
      params.password = await encryptPwd(params.password)
      try {
        const res = await userLogin(params)
        await userStore.login(res) // 保存个人信息

        const redirectUrl = $route.query.redirectUrl
          ? decodeURIComponent($route.query.redirectUrl)
          : '/'
        router.push(redirectUrl)

        ElMessage({
          message: t('form.loginSuccess'),
          type: 'success',
        })
      } catch (error) {
        if (error.code === 4011) {
          state.errorText = error.msg
          $emits('showError', true)
        } else {
          // console.log('error', error)
          state.errorText = ''
          // ElMessage({
          //   message: error.msg,
          //   type: 'error',
          // })
          $emits('showError', false)
        }
        verifyCodeRef.value.getCodeImg()
      } finally {
        state.isLoading = false
      }
    } else {
      state.isLoading = false
    }
  })
}
const googleLoginCallback = async (res) => {
  try {
    state.isLoading = true
    const token = res.credential
    const params = {
      token,
      deviceCode: finger(),
      device: 'pc',
    }
    const res1 = await googleLogin(params)
    await userStore.login(res1) // 保存个人信息

    const redirectUrl = $route.query.redirectUrl
      ? decodeURIComponent($route.query.redirectUrl)
      : '/'
    router.push(redirectUrl)

    ElMessage({
      message: t('form.loginSuccess'),
      type: 'success',
    })
  } catch (error) {
    ElMessage.error(error?.msg || error)
  } finally {
    state.isLoading = false
  }
}

onMounted(() => {
  !initGoogle('google-button', googleLoginCallback) &&
    useGoogle('google-button', googleLoginCallback)
})

defineExpose({ onSubmit })

function finger() {
  // 获取浏览器 User Agent 信息
  var userAgent = navigator.userAgent

  // 获取浏览器 Accept Headers 信息
  var acceptHeaders = navigator.acceptHeader

  // 获取屏幕分辨率
  var screenWidth = screen.width
  var screenHeight = screen.height

  // 获取时区偏移量
  var timezoneOffset = new Date().getTimezoneOffset()

  // 创建一个 Canvas 元素
  var canvas = document.createElement('canvas')
  var ctx = canvas.getContext('2d')

  // 绘制一个图像，并获取图像数据的哈希值
  var text = 'fingerprint'
  ctx.textBaseline = 'top'
  ctx.font = "14px 'Arial'"
  ctx.textBaseline = 'alphabetic'
  ctx.fillStyle = '#f60'
  ctx.fillRect(125, 1, 62, 20)
  ctx.fillStyle = '#069'
  ctx.fillText(text, 2, 15)
  ctx.fillStyle = 'rgba(102, 204, 0, 0.7)'
  ctx.fillText(text, 4, 17)

  var canvasData = canvas.toDataURL()
  var canvasHash = hash(canvasData)

  // 获取本地 IP 地址和端口号
  var rtcPeerConnection =
    window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
  if (rtcPeerConnection) {
    var pc = new rtcPeerConnection({
      iceServers: [],
    })
    pc.createDataChannel('')
    pc.createOffer(
      function (result) {
        pc.setLocalDescription(
          result,
          function () {
            //
          },
          function () {
            //
          },
        )
      },
      function () {
        //
      },
    )
    pc.onicecandidate = function (event) {
      if (event && event.candidate && event.candidate.candidate) {
        // var address = event.candidate.candidate.split(' ')[4];
        // var port = event.candidate.candidate.split(' ')[5];
        // var ip = address.split(':')[0];
      }
    }
  }

  // 整合上述信息生成浏览器指纹
  var fingerprint =
    userAgent + acceptHeaders + screenWidth + screenHeight + timezoneOffset + canvasHash

  // 计算哈希值
  function hash(str) {
    var hash = 0
    for (var i = 0; i < str.length; i++) {
      var char = str.charCodeAt(i)
      hash = (hash << 5) - hash + char
      hash = hash & hash
    }
    return hash
  }
  return CryptoJS.MD5(fingerprint).toString()
}
// const onGoGoogle = () => {
//   //
// };
</script>

<style lang="scss" scoped>
.tips-error {
  width: 400px;
  padding: 12px;
  background: var(--white-color-1)1e9;
  border-radius: 8px;
  // min-height: 64px;
  line-height: 22px;
  display: flex;
  // align-items: center;
  color: var(--border-black-1);
  font-size: 14px;
  margin-top: 20px;

  .warn-icon {
    width: 22px;
    height: 22px;
    margin-right: 8px;
  }

  ::v-deep {
    a {
      color: var(--primary-color);
    }
  }
}

.form-wrapper {
  width: 400px;
  margin-top: 20px;

  .ipt-common {
    width: 400px;
    height: 44px;
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  ::v-deep {
    .el-input {
      .el-input__inner {
        &::placeholder {
          font-family: Montserrat;
          font-size: 14px;
          color: #8492b2;
        }
      }

      .el-input__wrapper {
        height: 44px;
      }
    }

    .el-form-item__error {
      position: static;
    }
  }

  .submit-button {
    cursor: pointer;
    width: 400px;
    height: 56px;
    border-radius: 8px;
    text-align: center;
    line-height: 56px;
    background-color: var(--primary-color);
    // color: var(--white-color-1);
    margin-bottom: 20px;
    margin-top: 24px;
  }

  .other-tool {
    display: flex;
    justify-content: space-between;

    .hover-link {
      font-family: Montserrat;
      font-size: 14px;
      color: var(--primary-color);
      cursor: pointer;
    }
  }

  .google-tool {
    margin-top: 46px;
    margin-bottom: 15px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 500;
    color: var(--black-color-26);

    .line1 {
      height: 1px;
      background-color: #e7e7e7;
      width: 188px;
    }

    .line2 {
      height: 1px;
      background-color: #e7e7e7;
      width: 188px;
    }
  }

  #google-button {
    font-family: Montserrat;
    font-size: 16px;
    font-weight: bold;
    color: var(--black-color-3d);
    width: 400px;
    height: 56px;
    border-radius: 8px;
    // border: 1px solid var(--border-black-1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 48px;
    // cursor: pointer;

    .google-img {
      width: 24px;
      height: 24px;
      display: block;
      margin-right: 8px;
    }
  }

  .tip-tool {
    width: 100%;
    text-align: center;
    font-family: Montserrat;
    font-size: 14px;

    .text1 {
      color: var(--black-color-9);
    }

    .text2 {
      color: var(--primary-color);
      margin-left: 4px;
      cursor: pointer;
    }
  }
}
</style>
